//import {APPLYOO} from "../applyoo";
import {dataUtils} from "../js/dataUtils";
import {utils_log} from "../utils/utils_log";
// import {applyoo} from "../../App";
import {ApplyooNS} from "../applyooConstants";

export interface componentHandlers {
    ElementGuid:string,
    AliasName?:string,
    SubComponent?:string,

    DataBindStr?:string,

    onSystemEvent_AfterGetProjectInfo?:any,
    onSystemEvent_AfterInit?:any,
    onSystemEvent_NewPrimaryEntityRow?: any,
    onSystemEvent_AfterSetNewPrimaryEntityDefaults?: any,
    onSaveDataManageInfo?:any,
    saveDataToStore?:any,
    getSaveTags?:any,
    validateElementBeforeSave?:any,
    dataFiltersChanged?:any,
    repositoryChanged?:any,
    updateQueryFilter?:any,
    setQueryFilterVisualItems?:any,
    onChangeNewMessage?:any,
    //onChangeDescription?:any,
    updateSeveralFieldsInQueryFilter?:any,
    DataBindUpdated?:any,
    Rerender?:any,
    onSendComponentNotification?:any,
    onResize?:any,
    onQueryDataChanged?:any,
    onValidationErrorsChanged?:any,
    onElementDataChanged?:any,
    onSavedQueryFilter?:any,
    onMessageReceivedFromServer?:any,
    onFilesChanged?:any,
    onSaveFailed?:any,
    onSaveSucceed?:any,
    onValidationError?:any,
    onLogout?:any,

    onProjectFrameContainerDisposing?:any,

    onCustomEvent?:any,
    getDynamicFieldValidationInfo?:any,
    afterSaveQueryData?:any,
    onChangeDescription?:any,
    onSaveTask?:any,
    onCallFunctionWithResponse?:any,
    getApplyooResourceByCode?:any,
   // onKendo_GetSelectedRows?:any
}

//comment: register applyoo component
export const useApplyooComponent = (prmComponentHandlers:componentHandlers) => {
    let elementID = "";

    if (!!prmComponentHandlers.SubComponent){
        elementID = `${prmComponentHandlers.ElementGuid}_${prmComponentHandlers.SubComponent}`
    }
    else {
        elementID = prmComponentHandlers.ElementGuid
    }

    ApplyooNS.addComponentHandler(elementID,prmComponentHandlers)

    // ApplyooNS.dicComponentHandlers[elementID] = prmComponentHandlers;

    if (!!prmComponentHandlers.AliasName) {
        ApplyooNS.addComponentAlias(prmComponentHandlers.AliasName,prmComponentHandlers)
        //ApplyooNS.dicComponentHandlers[prmComponentHandlers.AliasName] = prmComponentHandlers;
    }

    // if (!!ApplyooNS.dicComponentStatistics[elementID]){
    //     ApplyooNS.dicComponentStatistics[elementID]["Render"]++;
    // }
    // else {
    //     ApplyooNS.dicComponentStatistics[elementID] = {
    //         Render: 1
    //     }
    // }

    utils_log.writeToLog(`*** useApplyooComponent: Rendering: ${elementID} - ${ApplyooNS.dicComponentStatistics[elementID]["Render"]} times` )
}

export const removeComponentHandler = (prmElementGuid:string, prmSubComponent?:string) => {
    let elementID = "";

    if (!!prmSubComponent){
        elementID = `${prmElementGuid}_${prmSubComponent}`
    }
    else {
        elementID = prmElementGuid
    }

    ApplyooNS.removeComponentHandler(elementID)
}

export const clearApplyooComponents = () => {
    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        // let lstGlobalComponents = Object.keys(ApplyooNS.dicComponentHandlers).filter((prmItem:any) => {
        //     return prmItem.startsWith("ApplyooGlobal")
        // })

        //comment: preserve ApplyooGlobal components
        // let dicNewCompoenentHandlers:any = {}
        // let dicNewCompoenentStatistics:any = {}

        let lstKeysToDelete:any = []
        for (const currComponentHandlerGuid in ApplyooNS.dicComponentHandlers) {
            if (!currComponentHandlerGuid.startsWith("ApplyooGlobal") && currComponentHandlerGuid != "ApplyooGlobal"){
                lstKeysToDelete.push(currComponentHandlerGuid)
                // dicNewCompoenentHandlers[currComponentHandlerGuid] = ApplyooNS.dicComponentHandlers[currComponentHandlerGuid]
                // dicNewCompoenentStatistics[currComponentHandlerGuid] = ApplyooNS.dicComponentStatistics[currComponentHandlerGuid]
            }
        }

        for (const currElementKey of lstKeysToDelete) {
            ApplyooNS.removeComponentHandler(currElementKey)
        }
        // ApplyooNS.dicComponentHandlers = dicNewCompoenentHandlers;
        // ApplyooNS.dicComponentStatistics = dicNewCompoenentStatistics;
    }
    else {
        ApplyooNS.dicComponentHandlers = {};
        ApplyooNS.dicComponentStatistics = {};
    }

}

//comment: send a notification to applyoo component in order to be resized
export const sendApplyooComponentsResize = () => {
    const timerId = setTimeout(() => {
        if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers) {
            for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
                if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]
                    && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["onResize"]) {
                    ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["onResize"]()
                }
            }
        }

        clearTimeout(timerId)
    }, 500)

}

export const sendApplyooComponentsFileChanged = (prmParams:any) => {
    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers) {
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
            if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]
                && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["onFilesChanged"]) {
                ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["onFilesChanged"](prmParams)
            }
        }
    }
}

//comment: send a notification to applyoo component to execute an internal command
export const sendApplyooComponentsNotification = (prmTargetElementGuid:string, prmTargetSubComponent:string, prmParams?:any) => {
    ApplyooNS.sendComponentNotification(prmTargetElementGuid, prmTargetSubComponent, prmParams)
    // let targetElement = prmTargetElementGuid;
    //
    // if (!!prmTargetSubComponent){
    //     targetElement = `${prmTargetElementGuid}_${prmTargetSubComponent}`
    // }
    //
    //
    // if (prmTargetSubComponent == "*") {
    //     if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
    //         for (const currElementKey in ApplyooNS.dicComponentHandlers) {
    //                 if (prmTargetElementGuid != currElementKey
    //                     && currElementKey.startsWith(`${prmTargetElementGuid}_`)
    //                     && !!ApplyooNS.dicComponentHandlers[currElementKey]?.onSendComponentNotification) {
    //                     ApplyooNS.dicComponentHandlers[currElementKey].onSendComponentNotification(prmParams)
    //                 }
    //         }
    //     }
    // }
    // else {
    //     if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
    //         if (!!ApplyooNS.dicComponentHandlers[targetElement]
    //             && !!ApplyooNS.dicComponentHandlers[targetElement]["onSendComponentNotification"]){
    //             ApplyooNS.dicComponentHandlers[targetElement]["onSendComponentNotification"](prmParams)
    //         }
    //     }
    //
    // }
}

export const callApplyooComponentWithResponse = (prmTargetElementGuid:string, prmTargetSubComponent:string, prmFunctionName:string, prmParams?:any) => {
    let outObj = null;
    let targetElement = prmTargetElementGuid;

    if (!!prmTargetSubComponent){
        targetElement = `${prmTargetElementGuid}_${prmTargetSubComponent}`
    }

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers
            && !!ApplyooNS.dicComponentHandlers[targetElement]
            && !!ApplyooNS.dicComponentHandlers[targetElement]?.onCallFunctionWithResponse) {
        outObj = ApplyooNS.dicComponentHandlers[targetElement]?.onCallFunctionWithResponse(prmFunctionName,prmParams)
    }

    return outObj;
}

export const getApplyooResourceByCode = (prmParams?:any) => {
    let outObj = null;

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
            if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]
                && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]?.getApplyooResourceByCode){
                outObj = ApplyooNS.dicComponentHandlers[currApplyooComponentGuid].getApplyooResourceByCode(prmParams)

                if (!!outObj) {
                    break;
                }
            }
        }
    }

    return outObj;
}

//comment: execute a common applyoo component function (for all component that contains implementation of the relevant function name)
export const executeApplyooComponentsFunction = (prmFunctionName:string, prmParams?:any) => {

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
            if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]
                && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid][prmFunctionName]){
                utils_log.writeToLog(`***executeApplyooComponentsFunction: ${currApplyooComponentGuid} func: ${prmFunctionName}`)
                ApplyooNS.dicComponentHandlers[currApplyooComponentGuid][prmFunctionName](prmParams)
            }
        }
    }
}

export const executeApplyooComponentsFunctionWithReturnValue = (prmFunctionName:string, prmParams?:any) => {

    let dicOut:any = {}

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
            if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]
                && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid][prmFunctionName]){
                let callResponse:any = ApplyooNS.dicComponentHandlers[currApplyooComponentGuid][prmFunctionName](prmParams)

                if (!!callResponse && Object.keys(callResponse).length > 0){
                    dicOut[currApplyooComponentGuid] = callResponse
                }
            }
        }
    }

    return dicOut
}

export const displayRegisteredApplyooComponents = () => {

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
            utils_log.writeToLog(currApplyooComponentGuid)
        }
    }
}

export const setPageData = (prmDataBindStr:string, prmDataObj:any ,prmMetadata?:any) => {
    dataUtils.setNestedJsonValue(ApplyooNS.dicDataStore, prmDataBindStr, prmDataObj, true);

    if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
        for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {

            let currComponentDataBindStr = ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["DataBindStr"];
            let currComponentDataBindUpdatedFunction = ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["DataBindUpdated"];

            if (!!currComponentDataBindStr
                && !!currComponentDataBindUpdatedFunction
                && (currComponentDataBindStr == prmDataBindStr || currComponentDataBindStr.startsWith(prmDataBindStr + "."))){
                currComponentDataBindUpdatedFunction(prmMetadata)
            }

        }
    }


    // dataUtils.setNestedJsonValue(APPLYOO.dicDataStore, prmDataBindStr, prmDataObj, true);
    // //utils_ui.setDataItem(prmDataBindStr, prmDataObj,true);
    //
    // for (const currApplyooComponentGuid in ApplyooNS.dicComponentHandlers) {
    //
    //
    //     if (!!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid]["DataBindStr"]
    //         && ApplyooNS.dicComponentHandlers[currApplyooComponentGuid].DataBindStr.startsWith(prmDataBindStr)
    //         && !!ApplyooNS.dicComponentHandlers[currApplyooComponentGuid].DataBindUpdated){
    //         ApplyooNS.dicComponentHandlers[currApplyooComponentGuid].DataBindUpdated(prmDataObj, prmMetadata);
    //     }
    // }
}